import {BaseComponentLifecycleEventHandler} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {ComponentController} from "../../../infrastructure/controllers/component-controller";
import {DeviceUtils} from "../../../infrastructure/utils/device-utils";
import {WebsiteModuleBrowserSearchKeyEvent} from "../models/website-module.browser-search.key-event";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {APP} from "../../../core/app/consts";

export class WebsiteModuleBrowserSearchEventHandler extends BaseComponentLifecycleEventHandler {
  deviceUtils: DeviceUtils;
  analyticsService: AnalyticsService;

  static injectables = [DeviceUtils, AnalyticsService];

  constructor(deviceUtils: DeviceUtils, analyticsService: AnalyticsService) {
    super();

    this.analyticsService = analyticsService;
    this.deviceUtils = deviceUtils;

    this.handleEvent = this.handleEvent.bind(this);
    this.registerEvent = this.registerEvent.bind(this);
  }

  onInitialized(controller: ComponentController) {
    super.onInitialized(controller);

    this.registerEvent();
  }

  registerEvent() {
    this.domUtils.createEvent("keypress", this.handleEvent);
    this.domUtils.createEvent("keydown", this.handleEvent);
  }

  handleEvent(event) {
    const isFKeyPressed = event.keyCode === 70;
    const isCtrlOrCmdPressed = this.deviceUtils.isMacOs ? event.metaKey : event.ctrlKey;

    if (isCtrlOrCmdPressed && isFKeyPressed) {
      const screen: APP.ANALYTICS.SOURCES = APP.ANALYTICS.SCREENS[this.navigationManager.currentLinkModel.name];
      const websiteModuleBrowserSearchKeyEvent: WebsiteModuleBrowserSearchKeyEvent = new WebsiteModuleBrowserSearchKeyEvent(screen);

      this.analyticsService.createEvent(websiteModuleBrowserSearchKeyEvent)
    }
  }
}
